<template>
    <div>
        <template>
            <div style="font-size:16px; background-color: #005B5B;">
                <h5 class="text-white text-center">
                    {{ data.tracking_no === 11
                      ? $t('externalUser.beneficiary_account')
                      : data.tracking_no === 8
                      ? $t('externalUser.pat_association_bank_info')
                      : data.tracking_no === 9
                      ? $t('externalUser.offender_beneficiary_account')
                      : data.tracking_no === 10
                      ? $t('externalUser.council_beneficiary_account')
                      : $t('externalUser.beneficiary_account_information') }}
                </h5>
            </div>
        </template>

        <b-table-simple bordered>
            <b-tr>
                <b-th>{{ $t('globalTrans.beneficiary_account_type') }}</b-th>
                <b-td>{{ data.account_type_name }}</b-td>
                <b-th>{{ $t('globalTrans.account_no') }}</b-th>
                <b-td>{{ beneficiary.account_no }}</b-td>
            </b-tr>
            <!-- <b-tr>
                <b-th>{{ $t('globalTrans.account_name_en') }}</b-th>
                <b-td>{{ beneficiary.account_name }}</b-td>
                <b-th>{{ $t('globalTrans.account_name_bn') }}</b-th>
                <b-td>{{ beneficiary.account_name_bn }}</b-td>
            </b-tr> -->

            <template v-if="beneficiary.category_id === 1">
                <b-tr>
                    <b-th>{{ $t('globalTrans.account_type') }}</b-th>
                    <b-td>{{ data.bank_account_type }}</b-td>
                    <b-th>{{ $t('globalTrans.account_name_x') }}</b-th>
                    <b-td>{{ $i18n.locale === 'bn' ? beneficiary.account_name_bn : beneficiary.account_name }}</b-td>
                </b-tr>
                <b-tr v-if="beneficiary.bank_id > 0">
                    <b-th>{{ $t('globalTrans.bank_name') }}</b-th>
                    <b-td>{{ bankName }}</b-td>
                    <b-th>{{ $t('globalTrans.branch_name') }}</b-th>
                    <b-td>{{ branchName }}</b-td>
                </b-tr>
                <b-tr v-else>
                    <b-th>{{ $t('globalTrans.bank_name') }}</b-th>
                    <b-td>{{ $i18n.locale === 'bn' ? beneficiary.bank_name_bn : beneficiary.bank_name }}</b-td>
                    <b-th>{{ $t('globalTrans.branch_name') }}</b-th>
                    <b-td>{{ $i18n.locale === 'bn' ? beneficiary.branch_name_bn : beneficiary.branch_name }}</b-td>
                </b-tr>
            </template>

            <template v-if="data.orphanage">
                <b-tr>
                    <b-th>{{ $t('externalUser.routing_no') }}</b-th>
                    <b-td v-if="data.orphanage.routing_no">{{ data.orphanage.routing_no }}</b-td>
                </b-tr>
            </template>

            <template v-if="beneficiary.category_id === 2">
                <b-tr>
                    <b-th>{{ $t('globalTrans.account_name_x') }}</b-th>
                    <b-td>{{ $i18n.locale === 'bn' ? beneficiary.account_name_bn : beneficiary.account_name }}</b-td>
                    <b-th>{{ $t('globalTrans.mfs_service') }}</b-th>
                    <b-td>{{ data.mfs_service }}</b-td>
                </b-tr>
            </template>
            <b-tr v-if="beneficiary.category_id === 1">
                <b-th v-if="beneficiary.branch_district_id">{{ $t('org_pro_district.district') }}</b-th>
                <b-td v-if="beneficiary.branch_district_id">{{ getDistrictName(beneficiary.branch_district_id) }}</b-td>
                <b-th v-if="beneficiary.routing_no">{{ $t('externalUser.routing_no') }}</b-th>
                <b-td v-if="beneficiary.routing_no">{{ beneficiary.routing_no }}</b-td>
            </b-tr>
        </b-table-simple>

        <!-- <b-row>
            <b-col xl="12" lg="12" sm="12" class="mt-2">
                <iq-card>
                    <div style="font-size:18px; background-color: #005B5B;">
                        <h5 class="text-white text-center"> {{ $t('globalTrans.beneficiary_account') }}
                        </h5>
                    </div>
                </iq-card>
            </b-col>
            <b-col lg="6" sm="6">
                <span class="font-weight-bold">{{$t('globalTrans.beneficiary_account_type')}} : </span> {{beneficiary.account_type_name}}
            </b-col>
            <b-col lg="6" sm="6" v-if="beneficiary.category_id===1">
                <span class="font-weight-bold">{{$t('globalTrans.bank_name_en')}} : </span> {{beneficiary.bank_name}}
            </b-col>
            <b-col lg="6" sm="6" v-if="beneficiary.category_id===1">
                <span class="font-weight-bold">{{$t('globalTrans.bank_name_bn')}} : </span> {{beneficiary.bank_name_bn}}
            </b-col>
            <b-col lg="6" sm="6" v-if="beneficiary.category_id===1">
                <span class="font-weight-bold">{{$t('globalTrans.branch_name_en')}} : </span> {{beneficiary.branch_name}}
            </b-col>
            <b-col lg="6" sm="6" v-if="beneficiary.category_id===1">
                <span class="font-weight-bold">{{$t('globalTrans.branch_name_bn')}} : </span> {{beneficiary.branch_name_bn}}
            </b-col>
            <b-col lg="6" sm="6" v-if="beneficiary.category_id===1">
                <span class="font-weight-bold">{{$t('globalTrans.account_type')}} : </span> {{beneficiary.bank_account_type}}
            </b-col>
            <b-col lg="6" sm="6" v-if="beneficiary.category_id===2">
                <span class="font-weight-bold">{{$t('globalTrans.mfs_service')}} : </span> {{beneficiary.mfs_service}}
            </b-col>
            <b-col lg="6" sm="6">
                <span class="font-weight-bold">{{$t('globalTrans.account_name_en')}} : </span> {{beneficiary.account_name}}
            </b-col>
            <b-col lg="6" sm="6">
                <span class="font-weight-bold">{{$t('globalTrans.account_name_bn')}} : </span> {{beneficiary.account_name_bn}}
            </b-col>
            <b-col lg="6" sm="6">
                <span class="font-weight-bold">{{$t('globalTrans.account_no')}} : </span> {{beneficiary.account_no}}
            </b-col>
        </b-row> -->
    </div>
</template>
<script>
// import Custom from '../../store/custom'
import RestApi, { commonServiceBaseUrl } from '@/config/api_config'

export default {
    props: ['data', 'admin'],
    data () {
        return {
            beneficiary: {},
            commonServiceBaseUrl: commonServiceBaseUrl,
            bankName: '',
            branchName: ''
        }
    },
    created () {
        this.beneficiary = this.data.beneficiary
    },
    watch: {
        'beneficiary.bank_id': function (newVal, oldVal) {
            if (this.beneficiary.bank_id > 0) {
                this.getBankName(newVal)
            }
        },
        'beneficiary.branch_id': function (newVal, oldVal) {
            if (this.beneficiary.branch_id > 0) {
                this.getBranchName(newVal)
            }
        }
    },
    methods: {
        getDistrictName (Id) {
            let tmpData = []
            if (this.$store.state.ExternalUser.commonObj.districtList.length) {
                 tmpData = this.$store.state.ExternalUser.commonObj.districtList.find(item => item.value === parseInt(Id))
            } else {
                 tmpData = this.$store.state.commonObj.districtList.find(item => item.value === parseInt(Id))
            }
            if (tmpData) {
                if (this.$i18n.locale === 'bn') {
                    return tmpData.text_bn
                } else {
                    return tmpData.text_en
                }
            } else {
                return ''
            }
        },
        async getBankName (Id) {
            const objectData = await RestApi.getData(commonServiceBaseUrl, 'common/bank-name', { id: Id })
            this.bankName = this.$i18n.locale === 'bn' ? objectData.text_bn : objectData.text_en
        },
        async getBranchName (Id) {
            const objectData = await RestApi.getData(commonServiceBaseUrl, 'common/branch-name', { id: Id })
            this.branchName = this.$i18n.locale === 'bn' ? objectData.text_bn : objectData.text_en
        },
        manipulateData () {
            const accountType = this.$store.state.commonObj.beneficiaryAccountType.find(item => item.value === this.beneficiary.category_id)
            const bankAccountType = this.$store.state.commonObj.bankAccountType.find(item => item.value === this.beneficiary.account_type_id)
            const mfsService = this.$store.state.commonObj.mfsService.find(item => item.value === this.beneficiary.mfs_service_id)
            let orgData
            if (this.$i18n.locale === 'bn') {
                orgData = {
                    account_type_name: accountType !== undefined ? accountType.text_bn : '',
                    bank_account_type: bankAccountType !== undefined ? bankAccountType.text_bn : '',
                    mfs_service: mfsService !== undefined ? mfsService.text_bn : ''
                }
            } else {
                orgData = {
                    account_type_name: accountType !== undefined ? accountType.text_en : '',
                    bank_account_type: bankAccountType !== undefined ? bankAccountType.text_en : '',
                    mfs_service: mfsService !== undefined ? mfsService.text_en : ''
                }
            }
            this.beneficiary = Object.assign({}, this.beneficiary, orgData)
        }
    }
}
</script>
